export default "{\n    \"emptyText\": \"Haga clic para seleccionar una categoría\",\n    \"placeholderText\": \"Buscar para filtrar...\"\n}\n"